<template>
    <home-template>
        <form>
            <div class="form-inline">
                <label for="game-id"> Enter Game ID: </label>
                <input class="form-control" v-model="gameId" @keydown.enter="joinGame()" id="game-id" placeholder="Type game ID here...">
            </div>
            <button @click.prevent="joinGame()" class="menu-btn"> Join Game! </button>
        </form>
    </home-template>
</template>

<script>
import HomeTemplate from '../components/HomeTemplate.vue';
import config from '../config';

export default {
    components: {
        HomeTemplate,
    },
    inject: ['socket'],
    data() {
        return {
            gameId: '',
        };
    },
    methods: {
        joinGame() {
            if(this.gameId.trim()){ 
                let uri = `/game/${this.gameId}`;
                if(config.production) {
                    uri = config.productionRoot + uri;
                }
                this.$router.push(uri);
            }
        },
    },
}
</script>

<style scoped>
.menu-btn{
    margin-top: 12px;
    border: 0;
}
label{
    color: rgba(238, 238, 238, 0.85);
}
</style>